import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getDevices(pageNumber: number, pageSize: number) {
  try {
    const resp = await axios.get(
      `/api/Device?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function searchDevices(query: object) {
  let searchQuery = getQueryString(query);
  try {
    const resp = await axios.get("/api/Device/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function DeviceLookup(wildXRNumber: string) {
  try {
    const resp = await axios.get(
      `/api/Device/device-lookup?wildXRNumber=${wildXRNumber}`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createDevice(device: object) {
  try {
    const resp = await axios.put("/api/Device/Create/", device);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateDevice(device: object) {
  try {
    const resp = await axios.post("/api/Device/Update/", device);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteDevice(deviceId: string) {
  try {
    const resp = await axios.delete("/api/Device/delete?id=" + deviceId);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getDeviceById(deviceId: string) {
  try {
    const resp = await axios.get("/api/Device/" + deviceId + "/details");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
